import { render, staticRenderFns } from "./assignment-validate-issue-task-modal.vue?vue&type=template&id=7422f46d&scoped=true"
import script from "./assignment-validate-issue-task-modal.vue?vue&type=script&lang=js"
export * from "./assignment-validate-issue-task-modal.vue?vue&type=script&lang=js"
import style0 from "./assignment-validate-issue-task-modal.vue?vue&type=style&index=0&id=7422f46d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7422f46d",
  null
  
)

export default component.exports